import React from 'react';

const Privacy = () => {
  return (
    <div className="max-w-7xl mx-auto px-4 py-12 sm:px-6 lg:px-8">
      <h1 className="text-3xl font-bold text-gray-900 mb-8">Politique de Confidentialité</h1>
      <div className="prose max-w-none">
        <section className="mb-8">
          <h2 className="text-2xl font-semibold text-gray-900 mb-4">Collecte des données</h2>
          <p className="text-gray-700 mb-4">
            Nous collectons uniquement les données personnelles nécessaires au bon fonctionnement de notre association et à la fourniture de nos services aux membres.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold text-gray-900 mb-4">Utilisation des données</h2>
          <p className="text-gray-700 mb-4">
            Les données collectées sont utilisées pour :
          </p>
          <ul className="list-disc pl-6 mb-4 text-gray-700">
            <li>La gestion de votre adhésion</li>
            <li>L'envoi d'informations relatives à nos activités</li>
            <li>L'amélioration de nos services</li>
          </ul>
        </section>

        <section>
          <h2 className="text-2xl font-semibold text-gray-900 mb-4">Vos droits</h2>
          <p className="text-gray-700 mb-4">
            Conformément à la LPD (Loi fédérale sur la protection des données), vous disposez d'un droit d'accès, de rectification et de suppression de vos données personnelles.
          </p>
        </section>
      </div>
    </div>
  );
};

export default Privacy;